import { render, staticRenderFns } from "./RightBox.vue?vue&type=template&id=b8b38b72&scoped=true&"
import script from "./RightBox.vue?vue&type=script&lang=js&"
export * from "./RightBox.vue?vue&type=script&lang=js&"
import style0 from "./RightBox.vue?vue&type=style&index=0&id=b8b38b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b38b72",
  null
  
)

export default component.exports